import { Button } from '@99designs/common/components/Button';
import { Icon } from '@99designs/common/components/Icon';
import { FormattedHTMLMessage } from '@99designs/common/i18n';
import Visible from 'common/components/Visible';
import { Color } from 'projects/consts';
import { redirectLaunchedBrief, redirectTo, routes } from 'projects/routes';
import React from 'react';
import ColorComponent from './Color';
import { DrawerOverlay } from './DrawerOverlay';

export const enum LaunchState {
    Success = 'Success',
    Error = 'Error',
}

interface Props {
    state: LaunchState;
    brief: {
        designers: { displayName: string }[];
        projectIds: number[];
    };
    showing: boolean;
}

const LaunchModal = ({ state, brief, showing }: Props) => {
    const isSingleDesigner = brief.designers.length == 1;
    return (
        <DrawerOverlay showing={showing} variations={['center']}>
            {state == LaunchState.Success && (
                <>
                    <ColorComponent color={Color.forrestLyf}>
                        <Icon type={'tick-3'} variations={['4x']} />
                    </ColorComponent>
                    <div className="heading heading--with-divider heading--h3">
                        {isSingleDesigner ? (
                            <FormattedHTMLMessage
                                message={__('Done!<br />We’ve sent your invite to {displayName}.')}
                                values={{ displayName: brief.designers[0].displayName }}
                            />
                        ) : (
                            <FormattedHTMLMessage
                                message={__(
                                    'Done!<br />We’ve sent out {number} invites on your behalf'
                                )}
                                values={{
                                    number: brief.projectIds.length,
                                }}
                            />
                        )}
                    </div>

                    <p className="paragraph">
                        {isSingleDesigner ? (
                            __('You’ll receive a response and/or quote within 24 hours.')
                        ) : (
                            <FormattedHTMLMessage
                                message={__(
                                    'You’ll start to receive responses and/or quotes from designers within 24 hours. You can keep an eye on progress from inside of <strong>Your Work.</strong>'
                                )}
                            />
                        )}
                    </p>
                    <ColorComponent color={Color.createBlue}>
                        <Visible sizes={['small', 'medium']}>
                            <Button
                                onClick={() => redirectLaunchedBrief(brief)}
                                variations={['primary', 'chameleon']}
                            >
                                {__('Continue')}
                            </Button>
                        </Visible>
                        <Visible sizes={['normal', 'large']}>
                            <Button
                                onClick={() => redirectLaunchedBrief(brief)}
                                variations={['primary', 'jumbo', 'chameleon']}
                            >
                                {__('Continue')}
                            </Button>
                        </Visible>
                    </ColorComponent>
                </>
            )}
            {state == LaunchState.Error && (
                <>
                    <ColorComponent color={Color.risingSun}>
                        <Icon type={'exclamation-point-2'} variations={['4x']} />
                    </ColorComponent>
                    <div className="heading heading--with-divider heading--h3">
                        <FormattedHTMLMessage
                            message={__('Uh oh!<br />Something has gone wrong')}
                        />
                    </div>
                    <p className="paragraph">
                        {__(
                            'Please try again in a couple of minutes or reach out to our friendly Support Team for help.'
                        )}
                    </p>
                    <ColorComponent color={Color.risingSun}>
                        <Visible sizes={['small', 'medium']}>
                            <Button
                                onClick={() => redirectTo(routes.support())}
                                variations={['primary', 'chameleon']}
                            >
                                {__('Contact support')}
                            </Button>
                        </Visible>
                        <Visible sizes={['normal', 'large']}>
                            <Button
                                onClick={() => redirectTo(routes.support())}
                                variations={['primary', 'jumbo', 'chameleon']}
                            >
                                {__('Contact support')}
                            </Button>
                        </Visible>
                    </ColorComponent>
                </>
            )}
        </DrawerOverlay>
    );
};

export default LaunchModal;
